"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormikExtended = _interopRequireDefault(require("@sprinx/react-forms/FormikExtended"));

var _styles = require("@material-ui/core/styles");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _useSnackbar3 = _interopRequireDefault(require("@sprinx/react-mui-layout/useSnackbar"));

var _FormTextField = _interopRequireDefault(require("../../components/FormTextField"));

var _useUserRenewPassword = _interopRequireDefault(require("./useUserRenewPassword"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column'
    },
    input: {
      width: '100%',
      '& label': {
        fontWeight: 500
      }
    },
    forgottenPasswordBtn: {
      color: theme.palette.primary.main,
      fontWeight: 500,
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1)
    },
    textContainer: (0, _extends2.default)({}, theme.typography.body1, {
      color: theme.palette.another.cart.grey,
      display: 'flex',
      flexDirection: 'column',
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      flexGrow: 1
    }),
    forgottenPasswordText: {
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5)
    },
    sendBtn: (0, _defineProperty2.default)({
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      alignSelf: 'center'
    }, theme.breakpoints.down('sm'), {
      alignSelf: 'initial',
      width: '50%'
    }),
    container: (0, _defineProperty2.default)({
      display: 'flex'
    }, theme.breakpoints.down('sm'), {
      flexDirection: 'column'
    })
  };
}, {
  name: 'RenewPasswordForm'
});
var initialValues = {
  email: ''
};
var validationSchema = {
  email: {
    type: 'email',
    empty: false
  }
};

function RenewPasswordForm(_ref) {
  var pClasses = _ref.classes,
      handleClose = _ref.onClose,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "onClose"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();

  var _useSnackbar = (0, _useSnackbar3.default)(),
      _useSnackbar2 = (0, _slicedToArray2.default)(_useSnackbar, 1),
      showMessage = _useSnackbar2[0];

  var renewPassword = (0, _useUserRenewPassword.default)();

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var handleSubmitForm = _react.default.useCallback( /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref2) {
      var email;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              email = _ref2.email;
              setError(null);
              renewPassword(email).then(function (data) {
                if (data === 'Done') {
                  handleClose();
                  showMessage(t('renewPasswordForm/success'), {
                    variant: 'success'
                  });
                } else {
                  showMessage(t('renewPasswordForm/emailNotFound'), {
                    variant: 'error'
                  });
                  setError('emailNotFound');
                }
              }).catch(function () {
                return showMessage(t('renewPasswordForm/error'), {
                  variant: 'error'
                });
              });

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [handleClose, renewPassword, showMessage, t]);

  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.forgottenPasswordBtn
  }, t('cartFormLogin/forgottenPasswordBtn')), /*#__PURE__*/_react.default.createElement(_FormikExtended.default, (0, _extends2.default)({}, rest, {
    initialValues: initialValues,
    validationSchema: validationSchema,
    validationFastest: true,
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: handleSubmitForm
  }), function (_ref4) {
    var errors = _ref4.errors,
        isSubmitting = _ref4.isSubmitting,
        handleChange = _ref4.onChange,
        handleSubmit = _ref4.onSubmit,
        values = _ref4.values;
    return /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react.default.createElement(_FormTextField.default, {
      type: "email",
      name: "forgettenPassword",
      id: "forgettenPassword",
      label: t('cartFormInvoice/email'),
      value: values.email,
      classes: {
        root: classes.input
      },
      onChange: handleChange('email'),
      error: errors.email
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.container
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.textContainer
    }, error === 'emailNotFound' ? /*#__PURE__*/_react.default.createElement("span", {
      className: classes.forgottenPasswordBtn
    }, t('renewPasswordForm/emailNotFound')) : null, /*#__PURE__*/_react.default.createElement("span", {
      className: classes.forgottenPasswordText
    }, t('cartFormLogin/text1')), /*#__PURE__*/_react.default.createElement("span", {
      className: classes.forgottenPasswordText
    }, t('cartFormLogin/text2'))), /*#__PURE__*/_react.default.createElement(_Button.default, {
      variant: "outlined",
      color: "secondary",
      className: classes.sendBtn,
      type: "submit",
      disable: isSubmitting
    }, t('cartFormLogin/btnSend'))));
  }));
}

process.env.NODE_ENV !== "production" ? RenewPasswordForm.propTypes = {
  classes: _propTypes.default.shape({
    container: _propTypes.default.string,
    forgottenPasswordBtn: _propTypes.default.string,
    forgottenPasswordText: _propTypes.default.string,
    input: _propTypes.default.string,
    root: _propTypes.default.string,
    sendBtn: _propTypes.default.string,
    textContainer: _propTypes.default.string
  }),
  onClose: _propTypes.default.func
} : void 0;
RenewPasswordForm.defaultProps = {
  classes: undefined,
  onClose: undefined
};
var _default = RenewPasswordForm;
exports.default = _default;